const shanghaiDateTime = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
})

// 无偏移的 LocalDateTime 保留业务钟面；显式偏移的时间按真实时刻转为上海时间。
export function formatRecordTime(value) {
  if (typeof value !== 'string') return '-'
  const match = value.trim().match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})(?::(\d{2}))?(?:\.\d+)?(Z|[+-]\d{2}:?\d{2})?$/)
  if (!match) return '-'
  const localTime = `${match[1]} ${match[2]}:${match[3] || '00'}`
  if (!match[4]) return localTime
  const offset = match[4].replace(/^([+-]\d{2})(\d{2})$/, '$1:$2')
  const instant = new Date(localTime.replace(' ', 'T') + offset)
  if (Number.isNaN(instant.getTime())) return '-'
  const parts = {}
  shanghaiDateTime.formatToParts(instant).forEach(part => { parts[part.type] = part.value })
  return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}:${parts.second}`
}

export function scoreText(value) {
  return value == null || value === '' || !Number.isFinite(Number(value)) ? '—' : Number(value).toFixed(2)
}

// 与 App 报告兼容：历史结构字段可能仍以 JSON 字符串返回。
export function toArray(value) {
  if (Array.isArray(value)) return value
  if (typeof value === 'string') {
    try { const parsed = JSON.parse(value); return Array.isArray(parsed) ? parsed : [] } catch (_) { return [] }
  }
  return []
}

export function toObject(value) {
  if (value && typeof value === 'object' && !Array.isArray(value)) return value
  if (typeof value === 'string') {
    try { return toObject(JSON.parse(value)) } catch (_) { return {} }
  }
  return {}
}

export function textSuggestions(value) {
  return toArray(value).filter(item => typeof item === 'string' && item.trim())
}
